<template>
  <section class="py-4 py-lg-5" id="footer">
    <div class="container-fluid contianer-lg">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 text-center">
          <!--
          <div class="footer-icon mb-2">
            <a class="me-3" href="https://www.facebook.com/dacodeng" target="_blank"><i class="fab fa-facebook-f"></i></a>
            <a class="me-3" href="https://www.linkedin.com/company/dacodeng" target="_blank"><i class="fab fa-linkedin"></i></a>
            <a href="https://api.whatsapp.com/send?phone=2348132961732&text=Hello%20Dacode%20%F0%9F%91%8B" target="_blank"><i class="fab fa-whatsapp"></i></a>
          </div>
          -->
          <p class="m-0">Copyright &copy; {{ new Date().getFullYear() }} | All rights reserved</p>
        </div>
      </div>
    </div>
      
    <button type="button"  @click="jumpTop" class="scroll-to-top" id="footer-scroll"><i class="fa fa-arrow-up"></i></button>
  </section>
</template>

<script>
export default {
  mounted(){
    window.onscroll = this.disabledTopButton 
  },
  methods: {
    disabledTopButton(){
      let myBtn = document.getElementById("footer-scroll");
      if(window.scrollY > 600){
        myBtn.style.display = "block";
      }else{
        myBtn.style.display = "none";
      }
    },
    jumpTop(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0; //Backward compatibility
    }
  }
}
</script>

<style>
#footer {
  background-color: var(--dacode-primary-color) !important;
  color: var(--dacode-white-color) !important;
  position: relative;
}

.footer-icon a {
  color: var(--dacode-white-color) !important;
}

.scroll-to-top {
  position: fixed;
  bottom: 6%;
  right: 3%;
  width: 60px;
  height: 60px;
  padding: 10px 16px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
  color: var(--dacode-white-color);
  background-color: var(--dacode-secondary-color);
  border: none;
  z-index: 99;
  cursor: pointer;
  transition: 500ms;
}

.scroll-to-top:hover {
  transform: translateY(-8px);
}
</style>
